import React, { useState, useEffect, useContext, useRef } from "react";
import { DataGrid } from "@mui/x-data-grid";
import {
  Container,
  Card,
  CardContent,
  Grid,
  Typography,
  Divider,
  TextField,
  Button,
  makeStyles,
} from "@material-ui/core";
import styled from "styled-components";
import Box from "@mui/material/Box"
import { convertFromRaw, convertToRaw, EditorState } from 'draft-js';

import { Link, useNavigate } from "react-router-dom";
import { useForm } from "react-hook-form";
import { useQuery, useManualQuery, useMutation, ClientContext } from "graphql-hooks";
import {UPDATE_TENANT_STATE_COUNTRY} from "../graphQL/tenant_qry";


const useStyles = makeStyles((theme) => ({
  root: {
    marginLeft: "8rem",
    marginRight: "8rem",
    marginTop: "2rem",
    textAlign: "center",
    padding: theme.spacing(2),
    minWidth: "500px",
  },
  container: {
    padding: theme.spacing(4),
    marginTop: "2rem",
    marginBottom: "5rem",
    overflow: "hidden",
    clear: "both",
  //  minWidth: "1000px",
    //height: "600px",
    borderRadius: "8px",
    backgroundColor: "#ffffff",
  },
  buttonStyle: {
    borderRadius: 4,
    width: "100px",
    padding: 0,
    color: "#fff",
    height: "34px",
    backgroundColor: "#0D47A1",
    textTransform: "none",
    // "&:active": {
    //   backgroundColor: "#765285",
    // },
    "&:hover": {
      backgroundColor: "#1E88E5",
    },
  },
}));



function TenantTest() {
  const classes = useStyles();
  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm();
  const form = useRef(null);
  const navigate = useNavigate();
  
  const [updateTenant] = useManualQuery(UPDATE_TENANT_STATE_COUNTRY, {fetchPolicy: "network-only",});

  const updateTenantDate = async () => {
    const {
      loading: loading,
      error: error,
      data: data,
    } = await updateTenant();
    
    if (!loading && data && data.updateTenantStateCountry) {
      console.log('test' , data.updateTenantStateCountry)
      
    }
  }
  
  useEffect(() => {
    updateTenantDate();
  }, []);

  
  
  return (
    <div className={classes.root} style={{ textAlign: 'left' }}>
      
      <div className={classes.container}>
        <Grid item lg={6} xl={6} md={4}>
          <Box mt={2} ml={2} mb={2} mr={2}>
           Test
          </Box>
        </Grid>
      </div>
    </div>
  );
}

export default TenantTest;
